export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14761.fcbe7d72.jpg";